import { useState } from 'react';

import useOn from './useOn';

/**
 * Custom Hook that on the `event` parameter, sets state to the first given parameter of the `on` callback 
 * @param event The event you want to listen fir
 * @param initialState The initial state
 * @returns Normal `useState` tuple
 */
const useStateOn = <S>(event: string, initialState: S): [S, React.Dispatch<S>] => {
	const stateTuple = useState<S>(initialState), [, setState] = stateTuple;

	useOn(event, setState);

	return stateTuple;
};

export default useStateOn;